module.exports = __webpack_public_path__ + "static/media/4.42667fe8.jpg";